"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _backgroundImage = _interopRequireDefault(require("./background-image"));
var _textBlock = _interopRequireDefault(require("./text-block"));
var _videoBackground = _interopRequireDefault(require("./video-background"));
var _discoverMitsubishi = _interopRequireDefault(require("../styles/discover-mitsubishi.css"));
var _lottieHotspotAnimation = require("@mmc/lottie-hotspot-animation");
var _discoverMitsubishi2 = _interopRequireDefault(require("./discover-mitsubishi.props/discover-mitsubishi.defaultProps"));
var _discoverMitsubishi3 = _interopRequireDefault(require("./discover-mitsubishi.props/discover-mitsubishi.propTypes"));
var _useMediaQuery = _interopRequireDefault(require("../utils/useMediaQuery"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating

var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  handleNestedProp = dataUtils.handleNestedProp;
var DiscoverMitsubishi = function DiscoverMitsubishi(props) {
  var _componentData$mobile;
  var data = props.data,
    theme = props.theme,
    defaultData = props.defaultData;
  var componentData = shouldUseDataOrDefaultProps(data, defaultData);
  var isDesktop = (0, _useMediaQuery["default"])('(min-width: 768px)');
  if (data && data.aiHotspotInfo) data.aiHotspotInfo.zIndex = 5;
  var mobileImageData = (_componentData$mobile = componentData.mobileImage) != null && _componentData$mobile.image ? componentData.mobileImage : componentData.image;
  var imgData = isDesktop ? handleNestedProp(componentData, 'componentData.image') : mobileImageData;
  var videoIsMissing = handleNestedProp(componentData, 'componentData.video.source') === ' ' || handleNestedProp(componentData, 'componentData.video.source') === null || handleNestedProp(componentData, 'componentData.video.source') === '';
  var showVideo = componentData.video && !videoIsMissing;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + _discoverMitsubishi["default"].discoverContainer + " " + theme.dark + " " + _discoverMitsubishi["default"][componentData.textBlockPosition]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _discoverMitsubishi["default"].imgContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-11'] + " " + _discoverMitsubishi["default"][componentData.textBlockPosition] + " " + _discoverMitsubishi["default"].imgColumn + " " + (showVideo && _discoverMitsubishi["default"].showVideo)
  }, !showVideo && data && data.aiHotspotInfo && /*#__PURE__*/_react["default"].createElement(_lottieHotspotAnimation.LottieHotspotAnimation, {
    data: data.aiHotspotInfo
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _discoverMitsubishi["default"].imageWrapper
  }, showVideo ? /*#__PURE__*/_react["default"].createElement(_videoBackground["default"], {
    theme: theme,
    data: componentData
  }) : /*#__PURE__*/_react["default"].createElement(_backgroundImage["default"], {
    imageData: imgData,
    theme: theme
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _discoverMitsubishi["default"].textBlockContainer
  }, /*#__PURE__*/_react["default"].createElement(_textBlock["default"], {
    data: componentData,
    theme: theme
  })))));
};
DiscoverMitsubishi.resourceType = function () {
  return 'DiscoverySection_1_0_0';
};
DiscoverMitsubishi.displayName = 'DiscoverMitsubishi';
DiscoverMitsubishi.defaultProps = {
  data: _discoverMitsubishi2["default"],
  defaultData: _discoverMitsubishi2["default"]
};
var _default = DiscoverMitsubishi;
exports["default"] = _default;